module.exports = __webpack_public_path__ + "img/right-box-en.545157db.png";